/* pamela-laser-library.js
   Laser etching library panel for Spot and Scene artwork.
   Requires pamela-laser-registry.js.
*/
(function () {
  "use strict";

  function el(tag, attrs, cssText) {
    const n = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach((k) => {
        if (k === "text") n.textContent = attrs[k];
        else if (k === "html") n.innerHTML = attrs[k];
        else n.setAttribute(k, attrs[k]);
      });
    }
    if (cssText) n.style.cssText = cssText;
    return n;
  }

  function titleCase(label) {
    return String(label || "")
      .trim()
      .replace(/[-_]+/g, " ")
      .replace(/\s+/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  function normalizeType(value) {
    const v = String(value || "").trim().toLowerCase();
    if (v === "scene" || v === "scenes") return "scene";
    return "spot";
  }

  function waitFor(fn, { timeoutMs = 10000, intervalMs = 50 } = {}) {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      const t = setInterval(() => {
        try {
          const v = fn();
          if (v) {
            clearInterval(t);
            resolve(v);
            return;
          }
          if (Date.now() - start > timeoutMs) {
            clearInterval(t);
            reject(new Error("Timed out waiting for laser library."));
          }
        } catch (_) {}
      }, intervalMs);
    });
  }

  function ensurePanel() {
    let panel = document.getElementById("pamela-laser-library-panel");
    if (panel) return panel;

    panel = el(
      "div",
      { id: "pamela-laser-library-panel" },
      "position:fixed;top:0;right:0;height:100vh;width:430px;max-width:94vw;" +
        "background:#fff;border-left:1px solid rgba(0,0,0,.15);z-index:2147483647;" +
        "box-shadow:-12px 0 30px rgba(0,0,0,.16);display:none;overflow:hidden;font-family:inherit;"
    );

    const header = el(
      "div",
      {},
      "padding:14px 14px;border-bottom:1px solid rgba(0,0,0,.12);display:flex;gap:10px;align-items:center;justify-content:space-between;"
    );
    header.appendChild(el("div", { text: "Laser Etching Library" }, "font-weight:900;font-size:17px;color:#111;"));
    const close = el(
      "button",
      { type: "button", text: "x", "aria-label": "Close laser library" },
      "width:40px;height:40px;border-radius:12px;border:1px solid rgba(0,0,0,.2);background:#fff;color:#111;font-size:22px;font-weight:900;cursor:pointer;"
    );
    close.addEventListener("click", () => { panel.style.display = "none"; });
    header.appendChild(close);

    const body = el("div", {}, "height:calc(100vh - 69px);overflow:auto;padding:14px;");

    const tabs = el("div", { id: "pamela-laser-library-tabs" }, "display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:12px;");
    const spotTab = el("button", { type: "button", "data-type": "spot", text: "Spot Etchings" }, "");
    const sceneTab = el("button", { type: "button", "data-type": "scene", text: "Scene Etchings" }, "");
    [spotTab, sceneTab].forEach((btn) => {
      btn.style.cssText = "height:42px;border-radius:999px;border:1px solid #111;background:#fff;color:#111;font-weight:900;cursor:pointer;";
      tabs.appendChild(btn);
    });

    const searchRow = el("div", {}, "display:flex;gap:8px;align-items:center;margin-bottom:10px;");
    const search = el(
      "input",
      { id: "pamela-laser-library-search", type: "text", placeholder: "Search laser designs..." },
      "flex:1;min-width:0;height:42px;box-sizing:border-box;padding:0 12px;border-radius:14px;border:1px solid rgba(0,0,0,.18);font-weight:900;font-size:14px;"
    );
    const clear = el(
      "button",
      { id: "pamela-laser-library-clear", type: "button", text: "Clear" },
      "height:42px;padding:0 14px;border-radius:14px;border:1px solid rgba(0,0,0,.18);background:#fff;font-weight:900;cursor:pointer;"
    );
    searchRow.appendChild(search);
    searchRow.appendChild(clear);

    const filters = el("div", {}, "display:flex;gap:10px;align-items:flex-start;margin-bottom:12px;flex-wrap:wrap;");
    const catLabel = el("label", {}, "display:flex;flex:1 1 165px;min-width:0;flex-direction:column;gap:5px;font-size:11px;font-weight:900;color:#555;");
    catLabel.appendChild(el("span", { text: "Category" }));
    const category = el(
      "select",
      { id: "pamela-laser-library-category" },
      "width:100%;height:42px;padding:0 34px 0 12px;border-radius:14px;border:1px solid rgba(0,0,0,.18);background:#fff;color:#111;font-weight:900;font-size:14px;cursor:pointer;"
    );
    catLabel.appendChild(category);

    const subLabel = el("label", {}, "display:flex;flex:1 1 165px;min-width:0;flex-direction:column;gap:5px;font-size:11px;font-weight:900;color:#555;");
    subLabel.appendChild(el("span", { text: "Subcategory" }));
    const subcategory = el(
      "select",
      { id: "pamela-laser-library-subcategory" },
      "width:100%;height:42px;padding:0 34px 0 12px;border-radius:14px;border:1px solid rgba(0,0,0,.18);background:#fff;color:#111;font-weight:900;font-size:14px;cursor:pointer;"
    );
    subLabel.appendChild(subcategory);

    filters.appendChild(catLabel);
    filters.appendChild(subLabel);

    const message = el("div", { id: "pamela-laser-library-message" }, "margin:0 0 10px;font-size:12px;line-height:1.3;font-weight:800;color:#444;");
    const grid = el("div", { id: "pamela-laser-library-grid" }, "display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;");

    body.appendChild(tabs);
    body.appendChild(searchRow);
    body.appendChild(filters);
    body.appendChild(message);
    body.appendChild(grid);
    panel.appendChild(header);
    panel.appendChild(body);
    document.body.appendChild(panel);
    return panel;
  }

  function itemMatches(it, q) {
    if (!q) return true;
    const hay = [it.id, it.name, it.rawName, it.type, it.category, it.subcategory].join(" ").toLowerCase();
    return hay.includes(q);
  }

  async function ensureLoaded() {
    await waitFor(() => typeof window.PAMELA_LASER_LIBRARY_ENSURE === "function", { timeoutMs: 10000 });
    await window.PAMELA_LASER_LIBRARY_ENSURE();
  }

  async function render(panel, options = {}) {
    const requestedType = normalizeType(options.type || panel.dataset.type || "spot");
    let activeType = requestedType;
    let activeCategory = "";
    let activeSubcategory = "";

    const tabs = Array.from(panel.querySelectorAll("#pamela-laser-library-tabs button"));
    const category = panel.querySelector("#pamela-laser-library-category");
    const subcategory = panel.querySelector("#pamela-laser-library-subcategory");
    const search = panel.querySelector("#pamela-laser-library-search");
    const clear = panel.querySelector("#pamela-laser-library-clear");
    const message = panel.querySelector("#pamela-laser-library-message");
    const grid = panel.querySelector("#pamela-laser-library-grid");

    try {
      await ensureLoaded();
    } catch (e) {
      console.error(e);
      if (message) message.textContent = "Laser library did not load. The Render endpoint may not be ready yet.";
      if (grid) grid.innerHTML = "";
      return;
    }

    function getCategories() {
      const cats = window.PAMELA_LASER_LIBRARY_CATEGORIES?.[activeType] || [];
      return cats.length ? cats : [{ id: "", label: "No categories yet" }];
    }

    function getActiveItems() {
      const q = String(search?.value || "").trim().toLowerCase();
      const all = q
        ? (window.PAMELA_LASER_LIBRARY_ALL || []).filter((it) => it.type === activeType)
        : (activeCategory
          ? (window.PAMELA_LASER_LIBRARY_BY_TYPE_CAT?.[activeType]?.[activeCategory] || [])
          : (window.PAMELA_LASER_LIBRARY_BY_TYPE?.[activeType] || []));

      return all.filter((it) => {
        if (!itemMatches(it, q)) return false;
        if (!q && activeSubcategory) return String(it.subcategoryId || "") === activeSubcategory;
        return true;
      });
    }

    function drawTabs() {
      tabs.forEach((btn) => {
        const isActive = btn.dataset.type === activeType;
        btn.style.background = isActive ? "#111" : "#fff";
        btn.style.color = isActive ? "#fff" : "#111";
      });
    }

    function drawCategories() {
      const cats = getCategories();
      category.innerHTML = "";
      cats.forEach((c) => {
        category.appendChild(el("option", { value: c.id, text: titleCase(c.label || c.id) }));
      });
      if (!activeCategory || !cats.some((c) => c.id === activeCategory)) {
        activeCategory = cats[0]?.id || "";
      }
      category.value = activeCategory;
    }

    function drawSubcategories() {
      const subs = typeof window.PAMELA_LASER_GET_SUBCATEGORIES === "function"
        ? window.PAMELA_LASER_GET_SUBCATEGORIES(activeType, activeCategory)
        : [];
      subcategory.innerHTML = "";
      subcategory.appendChild(el("option", { value: "", text: "All" }));
      subs.forEach((s) => subcategory.appendChild(el("option", { value: s.id, text: titleCase(s.label) })));
      if (!subs.some((s) => s.id === activeSubcategory)) activeSubcategory = "";
      subcategory.value = activeSubcategory;
    }

    function drawGrid() {
      const items = getActiveItems();
      const typeLabel = activeType === "scene" ? "scene" : "spot";
      if (message) {
        message.textContent = activeType === "scene"
          ? "Choose a scene design. The final price still uses the placed size on the monument."
          : "Choose a spot design. If it is placed larger than spot size, it will price as a scene.";
      }
      grid.innerHTML = "";
      if (!items.length) {
        grid.innerHTML = `<div style="grid-column:1/-1;opacity:.75;font-weight:900;">No ${typeLabel} designs found.</div>`;
        return;
      }

      items.forEach((it) => {
        const cell = el(
          "button",
          { type: "button", title: [it.category, it.subcategory, it.name].filter(Boolean).join(" - ") },
          "border:1px solid rgba(0,0,0,.14);border-radius:14px;background:#fff;padding:8px;cursor:pointer;display:flex;flex-direction:column;gap:7px;align-items:center;"
        );
        const img = el(
          "img",
          { src: it.url, alt: it.name || "", loading: "lazy" },
          "width:100%;height:124px;object-fit:contain;display:block;background:#f6f6f6;border-radius:10px;"
        );
        const cap = el("div", { text: titleCase(it.name || it.subcategory || "Laser Design") }, "font-size:12px;line-height:1.15;font-weight:900;text-align:center;color:#111;");
        const meta = el("div", { text: [it.category, it.subcategory].filter(Boolean).join(" / ") }, "font-size:10px;line-height:1.15;font-weight:800;text-align:center;color:#666;");
        cell.appendChild(img);
        cell.appendChild(cap);
        if (meta.textContent) cell.appendChild(meta);
        cell.addEventListener("click", async () => {
          const originalCap = cap.textContent;
          const originalMeta = meta.textContent;
          cell.disabled = true;
          cell.style.opacity = ".65";
          cap.textContent = "Placing...";
          meta.textContent = "";
          try {
            const replaceNode = options?.replaceNode || null;
            if (typeof window.PAMELA_ADD_LASER_LIBRARY_TO_STAGE === "function") {
              await window.PAMELA_ADD_LASER_LIBRARY_TO_STAGE(it, { replaceNode });
            } else if (typeof window.PAMELA_placeLaserArtworkFromUrl === "function") {
              await window.PAMELA_placeLaserArtworkFromUrl(it.url, {
                source: "library",
                name: it.name || "",
                original_name: it.name || "",
                content_type: it.contentType || "",
                width: it.width || 0,
                height: it.height || 0,
                replaceNode,
                preserveReplacementSize: false
              });
            } else {
              throw new Error("Laser placement hook is not available.");
            }
            close();
          } catch (e) {
            console.error(e);
            cap.textContent = "Could not load. Try again.";
            meta.textContent = e?.message || originalMeta || "";
            cell.disabled = false;
            cell.style.opacity = "1";
            window.setTimeout(() => {
              if (!cell.isConnected) return;
              cap.textContent = originalCap;
              meta.textContent = originalMeta;
            }, 4500);
          } finally {
            if (cell.isConnected && cell.disabled && cap.textContent === "Placing...") {
              cell.disabled = false;
              cell.style.opacity = "1";
              cap.textContent = originalCap;
              meta.textContent = originalMeta;
            }
          }
        });
        grid.appendChild(cell);
      });
    }

    function draw() {
      drawTabs();
      drawCategories();
      drawSubcategories();
      drawGrid();
    }

    tabs.forEach((btn) => {
      btn.onclick = () => {
        activeType = normalizeType(btn.dataset.type || "spot");
        activeCategory = "";
        activeSubcategory = "";
        if (search) search.value = "";
        draw();
      };
    });

    category.onchange = () => {
      activeCategory = category.value;
      activeSubcategory = "";
      drawSubcategories();
      drawGrid();
    };

    subcategory.onchange = () => {
      activeSubcategory = subcategory.value;
      drawGrid();
    };

    search.oninput = drawGrid;
    clear.onclick = () => {
      search.value = "";
      drawGrid();
    };

    draw();
  }

  async function open(options = {}) {
    const panel = ensurePanel();
    panel.dataset.type = normalizeType(options.type || "spot");
    panel.style.display = "block";
    await render(panel, options);
  }

  function close() {
    const panel = document.getElementById("pamela-laser-library-panel");
    if (panel) panel.style.display = "none";
  }

  async function toggle(options = {}) {
    const panel = ensurePanel();
    const opening = panel.style.display === "none" || !panel.style.display;
    if (opening) await open(options);
    else close();
  }

  window.PAMELA_LASER_LIBRARY_UI = { open, close, toggle };
})();
